import { CallStatus } from "modules/Call/queries"

export function canStartCall(callStatus?: CallStatus) {
    return !!callStatus && ["UPCOMING", "CURRENT", "STARTED"].includes(callStatus)
}
